export var canPlayType=function(e){return document.createElement("video").canPlayType(e)};